import React from "react";
import { connect } from "react-redux";
import { EnquiryStatusJson } from "../../../DynamicFormsJson/MastersJSON/enquiryStatus";
import { getEnquiryStatus } from "../../../Slice/enquiryOperations.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { EnquiryStatusColumns } from "../../../tableColumns/table-columns";

class EnquiryStatus extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { enquiryStatus, getEnquiryStatus } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={EnquiryStatusJson.formPath}
                    screenTitle={EnquiryStatusJson.screenTitle}
                    fieldMeta={EnquiryStatusJson.fieldMeta}
                    showPdfDownload={EnquiryStatusJson.showPdfDownload}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={EnquiryStatusJson.pdfFileName}
                    excelFileName={EnquiryStatusJson.excelFileName}
                    showAddButton={EnquiryStatusJson.showAddButton}
                    tableColumnsToFilter={EnquiryStatusJson.tableColumnsToFilter}
                    tableColumns={EnquiryStatusColumns}
                    tableData={enquiryStatus?.enquiryStatus}
                    getTableData={getEnquiryStatus}
                    apiBaseURL={EnquiryStatusJson.apiBaseURL}
                    baseIdColumn={EnquiryStatusJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={EnquiryStatusJson.noteValue}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    isActiveURL={EnquiryStatusJson.isActiveURL}
                    isActiveURLGET={true}
                    showView={false}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    enquiryStatus: state.enquiryOperations,
});

const mapDispatchToProps = {
    getEnquiryStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryStatus);